import React, { FC } from "react";
import { Dialog as MuiDialog } from "@mui/material";

type Props = React.ComponentProps<typeof MuiDialog>;

const Dialog: FC<Props> = (props) => {
    return <MuiDialog {...props}/>
}

export default Dialog;